import { Quill } from 'react-quill'

export class ClearImageResize {
  private editor: any

  constructor(quill: typeof Quill) {
    this.editor = quill

    this.editor.root.addEventListener('scroll', this.clearImageResizeSelection, false)
    this.editor.root.addEventListener('click', this.addImageResizeSelection, false)
  }

  private clearImageResizeSelection = () => {
    if (!this.editor.hasFocus()) {
      this.editor.root.click()
      this.editor.blur()
    }
  }

  private addImageResizeSelection = (event: any) => {
    if (event.target?.tagName === 'IMG') {
      this.editor.container.classList.add('image-resizing')
    } else {
      this.editor.container.classList.remove('image-resizing')
    }
  }
}
